import { FC } from "react";
import { InputComponent } from "./CalculatorSelectInput";
import { makeStyles } from "@material-ui/core";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  inputContainer: {
    margin: "0 12px",
  },
  inputLabel: {
    fontWeight: "bold",
    marginLeft: "10px",
    "@media (min-width: 578px)": {
      marginTop: "25px",
      marginLeft: "0px",
    },
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    "@media (min-width: 578px)": {
      width: "80%",
      flexDirection: "column",
      marginBottom: "0px",
    },
  },
}));

const InputWithMarginBottom: FC<{ onChange: any; name?: string; value?: any; label: string }> = ({
  onChange,
  name,
  value,
  label,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.inputContainer}>
      <div className={classes.inputWrapper}>
        <InputComponent onChange={onChange} name={name || ""} result="" value={value || ""} />
        <div className={classes.inputLabel}>{label}</div>
      </div>
    </div>
  );
};

export default InputWithMarginBottom;
